import { HTMLSelect, IHTMLSelectProps } from '@blueprintjs/core'
import * as React from 'react'
import Countries from '../constants/Countries'
import { resolveCountryValue } from '../routes/shipments/new/components/label_form/utils'

const CountryOpts = Countries.map(c => {
  return (
    <option key={c.name} value={c.abbreviation}>
      {c.name}
    </option>
  )
})

const CountrySelect: React.FC<IHTMLSelectProps> = props => {
  const value = resolveCountryValue(props.value as string) || 'Choose a country...'
  return (
    <HTMLSelect {...props} onChange={props.onChange} value={value}>
      <option label="Choose a country" />
      {CountryOpts}
    </HTMLSelect>
  )
}

export default CountrySelect
